<template>
  <div>
    <div v-if="currentPath">
      <Navbar/>
    </div>
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  components: {
    Navbar
  },
  computed: {
    currentPath() {
      return this.$route.path !== '/'; // Path (e.g., /home)
    }
  }
}
</script>

<style>
body {
  font-family: "Poppins", sans-serif;
}
</style>
